import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const warehouseManagementRoutes: RouteConfig[] = [
  {
    path: "/warehouse-management",
    component: Layout,
    redirect: "/warehouse-management/space",
    name: "WarehouseManagement",
    meta: {
      title: "warehouseManagement",
      icon: "el-icon-s-shop",
      alwaysShow: true,
    },
    children: [
      {
        path: "space",
        component: () => import("@/views/warehouse-management/space/index.vue"),
        name: "StorageManagement",
        meta: { title: "spaceManagement" },
      },
      {
        path: "inventory-overview-diagram",
        component: () =>
          import(
            "@/views/warehouse-management/DeliveryNoteStorageManagement.vue"
          ),
        name: "DeliveryNoteStorageManagement",
        meta: { title: "deliveryNoteStorageManagement" },
      },
      {
        path: "warehouse-entry-guide-diagram",
        component: () =>
          import(
            "@/views/warehouse-management/warehouse-entry-guide-diagram/WareHouseEntryGuideDiagram.vue"
          ),
        name: "WareHouseEntryGuideDiagram",
        meta: { title: "wareHouseEntryGuideDiagram" },
      },
      {
        path: "inventory-plans",
        component: () =>
          import("@/views/warehouse-management/InventoryPlanManagement.vue"),
        name: "InventoryPlanManagement",
        meta: { title: "inventoryPlan" },
      },
      {
        path: "inventory-plans/:inventoryPlanId",
        component: () =>
          import("@/views/warehouse-management/InventoryPlanDetail.vue"),
        name: "InventoryPlanDetail",
        meta: { title: "inventoryPlanDetail", hidden: true },
      },
    ],
  },
];

export default warehouseManagementRoutes;
